import { Controller } from "@hotwired/stimulus"

// Actualiza íconos de sesiones sin plan según el rango de vigencia seleccionado.
export default class extends Controller {
  static targets = ["chip", "includedIcon", "excludedIcon"]
  static values = { quota: Number }

  connect () {
    this.startInput = this.element.querySelector('[data-date-range-picker-target="startInput"]')
    this.endInput = this.element.querySelector('[data-date-range-picker-target="endInput"]')

    this.boundUpdate = this.update.bind(this)
    if (this.startInput) this.startInput.addEventListener("input", this.boundUpdate)
    if (this.endInput) this.endInput.addEventListener("input", this.boundUpdate)

    this.update()
  }

  disconnect () {
    if (this.startInput) this.startInput.removeEventListener("input", this.boundUpdate)
    if (this.endInput) this.endInput.removeEventListener("input", this.boundUpdate)
  }

  update () {
    const start = this.startInput?.value
    const end = this.endInput?.value || start
    const limit = this.quotaValue > 0 ? this.quotaValue : Number.POSITIVE_INFINITY

    if (!start) {
      this.setIconState(false)
      return
    }

    const eligible = this.chipTargets
      .filter((chip) => {
        const sessionDate = chip.dataset.sessionDate
        if (!sessionDate) return false
        if (sessionDate < start) return false
        if (end && sessionDate > end) return false
        return true
      })
      .sort((a, b) => (a.dataset.sessionAt || "").localeCompare(b.dataset.sessionAt || ""))

    const included = new Set(eligible.slice(0, limit))

    this.chipTargets.forEach((chip) => {
      this.setChipIncluded(chip, included.has(chip))
    })
  }

  setIconState (included) {
    this.chipTargets.forEach((chip) => {
      this.setChipIncluded(chip, included)
    })
  }

  setChipIncluded (chip, included) {
    const includedIcon = chip.querySelector('[data-subscription-booking-preview-target="includedIcon"]')
    const excludedIcon = chip.querySelector('[data-subscription-booking-preview-target="excludedIcon"]')
    if (includedIcon) includedIcon.classList.toggle("hidden", !included)
    if (excludedIcon) excludedIcon.classList.toggle("hidden", included)
  }
}
